// src/components/Phone.jsx
import React from "react";
import "./Phone.css";

const sizeScaleMap = {
  small: 0.8,
  medium: 0.9,
  regular: 1,
};

const Phone = ({ children, size = "regular" }) => {
  const normalizedSize = ["small", "medium", "regular"].includes(size)
    ? size
    : "regular";

  const scale = sizeScaleMap[normalizedSize];

  return (
    <div className={`phone-wrapper phone-wrapper--${normalizedSize}`}>
      <div className="phone-body" style={{ "--phone-scale": scale }}>
        {/* Side buttons */}
        <div className="phone-button phone-button--left phone-button--volume" />
        <div className="phone-button phone-button--left phone-button--silent" />
        <div className="phone-button phone-button--right phone-button--power" />

        {/* Notch / speaker */}
        <div className="phone-notch" />

        {/* Main screen */}
        <div className="phone-screen">
          {/* Status bar */}
          <div className="phone-status-bar">
            <span className="phone-status-time">10:01</span>
            <div className="phone-status-icons">
              {/* Signal bars */}
              <div className="phone-signal">
                <span className="signal-bar signal-bar--active" />
                <span className="signal-bar signal-bar--active" />
                <span className="signal-bar signal-bar--active" />
                <span className="signal-bar signal-bar--inactive" />
              </div>

              {/* Wi-Fi */}
              <div className="wifi-icon">
                <span className="wifi-dot" />
              </div>

              {/* Battery */}
              <div className="battery">
                <div className="battery-body">
                  <div className="battery-level" />
                </div>
                <div className="battery-tip" />
              </div>
            </div>
          </div>

          {/* App content */}
          <div className="phone-content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Phone;
